// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__22Q7B","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2WFrb"};